// extracted by mini-css-extract-plugin
export default {"serviceCommission":"ServiceCommission_serviceCommission__g55fI","label":"ServiceCommission_label__znEa4","value":"ServiceCommission_value__PbWuI"};